__webpack_require__.p = "https://us-west-2.prod.categorymanagement.wwgs.amazon.dev/";